export enum SEARCH {
  CODE = "code",
  FOCUS = "focus",
  STATE = "state",
}
